import React from 'react';

import type { BaseCardProps } from '../types';

const CardTitle: React.FC<Pick<BaseCardProps, 'title'>> = (props) => {
  const { title } = props;

  return (
    <h3 className="Card__title">{title}</h3>
  );
};

export default CardTitle;
